import { Stack, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { ApiError } from "../../Api/ApiError";
import { AccessKeyList, AccessLevelList, SetAccessKey } from "../../Api/Staff";
import { AccessKey } from "../../Objects/AccessKey";
import { AccessLevel } from "../../Objects/AccessLevel";
import PageTitle from "../atoms/PageTitle";
import { AccessLevelCard } from "../molecules/AccessLevelCard";

const AuthConfigPage: React.FC = () => {
    const { enqueueSnackbar } = useSnackbar()

    const [accessKeyList, setAccessKeyList] = React.useState<AccessKey[]>()
    const [accessLevelList, setAccessLevelList] = React.useState<AccessLevel[]>()

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    const loadAccessLevel = React.useCallback((acle_id?: number) => {
        AccessLevelList(acle_id, {signal: abortController.signal}).then(list => {
            if (acle_id) {
                setAccessLevelList( prev => {
                    const acl_list: AccessLevel[] = prev ? prev.map(val => val.acle_id === acle_id ? list[0] : val) : []
                    return acl_list
                })
            } else {
                setAccessLevelList(list)
            }
        }).catch((e: any) => {
            if( e.__CANCEL__ ) {
                console.info("canceled")
            } else if (e instanceof ApiError) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else if (e instanceof Error) {
                enqueueSnackbar(e.message, { variant: "error" })
            }else {
                enqueueSnackbar("通信に失敗しました", { variant: "error" })
            }
        })
    }, [abortController, enqueueSnackbar])

    const doSave = React.useCallback((val: AccessLevel) => {
        SetAccessKey({
            acle_id: val.acle_id,
            acky_list: val.acky_list
        }, {signal: abortController.signal}).then(() => {
            enqueueSnackbar("保存しました", { variant: "success" })
            loadAccessLevel(val.acle_id)
        }).catch((e: any) => {
            if( e.__CANCEL__ ) {
                console.info("canceled")
            } else if (e instanceof ApiError) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else if (e instanceof Error) {
                enqueueSnackbar(e.message, { variant: "error" })
            }else {
                enqueueSnackbar("通信に失敗しました", { variant: "error" })
            }
        })
    }, [abortController, loadAccessLevel, enqueueSnackbar])

    React.useEffect(() => {
        const controller = new AbortController()
        AccessKeyList({signal: controller.signal}).then(list => {
            setAccessKeyList(list)
        }).catch((e: any) => {
            if( e.__CANCEL__ ) {
                console.info("canceled")
            } else if (e instanceof ApiError) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else if (e instanceof Error) {
                enqueueSnackbar(e.message, { variant: "error" })
            }else {
                enqueueSnackbar("通信に失敗しました", { variant: "error" })
            }
        })

        loadAccessLevel()
        return () => {
            controller.abort()
        }
    }, [enqueueSnackbar, loadAccessLevel])

    if (!accessKeyList || !accessLevelList) {
        return <Typography>Loading...</Typography>
    }
    return (
        <>
            <PageTitle text="アクセス権限管理" />
            <Stack
                spacing={2}
            >
                {accessLevelList.map(accessLevel => (
                    <AccessLevelCard
                        accessLevel={accessLevel}
                        accessKeyList={accessKeyList}
                        key={accessLevel.acle_id}
                        onSave={val => {
                            doSave(val)
                        }}
                    />
                ))}
            </Stack>
        </>
    )
}

export default AuthConfigPage